import React, { useState } from 'react';
import {
	Dialog,
	DialogContent,
	makeStyles,
	Box,
	useTheme,
	useMediaQuery,
	Grid,
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import SuccessModal from './SuccessModal';
import { toggleRegisterModal } from '../../reducers/UiReducer';
import { agentlogoDispatch } from '../../reducers/UserReducer';
import ErrorModal from './ErrorModal';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: 'transparent',
		backdropFilter: 'blur(2px)',
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(3),
		[theme.breakpoints.down('xs')]: {
			top: theme.spacing(2.5),
		},
		color: theme.palette.grey[500],
	},
	nextButton: {
		backgroundColor: '#E61855',
		color: 'white',
		borderColor: '#E61855',
		borderRadius: 15,
		fontWeight: 600,
		width: '100%',
		padding: 10,
		'&:hover': {
			backgroundColor: '#E61855',
		},
	},
}));

const SessionExpireModal = () => {
	const classes = useStyles();
	const history = useHistory();
	const { session } = useSelector((state) => state.ui);

	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('xs'));

	return (
		<Dialog
			PaperProps={{
				style: {
					borderRadius: 20,
					maxWidth: 700,
				},
			}}
			TransitionProps={{
				style: { backgroundColor: 'transparent' },
			}}
			// onClose={handleClose}
			aria-labelledby='customized-dialog-title'
			className={classes.root}
			open={session}
			fullWidth={true}
			maxWidth={'xs'}>
			<DialogContent
				style={{
					paddingBottom: 20,
					paddingTop: 20,
				}}>
				<h2
					three={matches ? false : true}
					style={{ fontWeight: 600, textAlign: 'center' }}>
					!!! Session Expired !!!
				</h2>

				<Grid container>
					<Grid item xs={4}></Grid>
					<Grid item xs={4}>
						<div
							className={classes.nextButton}
							style={{ textAlign: 'center', cursor: 'pointer' }}
							onClick={() => history.push('/')}>
							Back To Home
						</div>
					</Grid>
					<Grid item xs={4}></Grid>
				</Grid>
				<SuccessModal />
				<ErrorModal />
			</DialogContent>
		</Dialog>
	);
};

export default SessionExpireModal;
